import { render, staticRenderFns } from "./globalUploader.vue?vue&type=template&id=27478ab1&scoped=true"
import script from "./globalUploader.vue?vue&type=script&lang=js"
export * from "./globalUploader.vue?vue&type=script&lang=js"
import style0 from "./globalUploader.vue?vue&type=style&index=0&id=27478ab1&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27478ab1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27478ab1')) {
      api.createRecord('27478ab1', component.options)
    } else {
      api.reload('27478ab1', component.options)
    }
    module.hot.accept("./globalUploader.vue?vue&type=template&id=27478ab1&scoped=true", function () {
      api.rerender('27478ab1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/video/component/globalUploader.vue"
export default component.exports